import React from 'react';
import { AttentionAndSystem } from '../components/AttentionAndSystem';
import { BrandPlatform } from '../components/BrandPlatform';
import { Hero } from '../components/Hero';
import { Manifesto } from '../components/Manifesto';
import { PageShell } from '../components/PageShell';
import { PricingSection } from '../components/PricingSection';
import { Products } from '../components/Products';
export function HomePage() {
  return <PageShell data-id="element-939" data-mp="2x1adkg9w0l1l">
      <Hero data-id="element-940" data-mp="2x0sap0spz8kp" />
      <AttentionAndSystem data-id="element-941" data-mp="2wy63j29qqv30" />
      <Products data-id="element-942" data-mp="2s1xv07q1u04t" />
      <BrandPlatform data-id="element-943" data-mp="2s2h18r6c7030" />
      <PricingSection data-id="element-944" data-mp="2s2z80hqmkwp6" />
      <Manifesto data-id="element-945" data-mp="2rzbevjp3ecaz" />
    </PageShell>;
}